import * as yup from 'yup';

import { ShareProject } from 'shared/generated-models';

export const shareProjectFormValidationSchema: yup.SchemaOf<ShareProject> = yup.object().shape({
	email: yup
		.string()
		.required('Email is required')
		.email('Enter a valid email')
		.max(50, 'Email must be at most 50 characters'),
	message: yup.string()
});
